import React, {useState, useEffect, useCallback /* , useRef */} from 'react';
import {authEventBus, AUTH_EVENTS} from '../utils/AuthEvents';
import {NavLink, useLocation} from 'react-router-dom';
import {FiX} from 'react-icons/fi';
import {FirstHeadManifestMenu, SecondHeadManifestMenu} from '../components/modules/pannelli/MenuMobile';

import {useThemes} from '../components/hooks/hooks-mongoDB/useThemes';
import { showToast } from '../contexts/ToastNotification';
import useAuth from '../components/hooks/hooks-e-commerce/useAuth'; 
import useCart from '../components/hooks/hooks-e-commerce/useCart';

import { useLoginModal } from '../contexts/LoginModalContext';
import normaLoginIcon from '../components/images/icons/iconLoginW50.png'; 
import hoverLoginIcon from '../components/images/icons/iconLoginYelloW50.png'; 
import normaAccountIcon from '../components/images/icons/iconSignUpW50.png'; 
import hoverAccountIcon from '../components/images/icons/iconSignUpYelloW50.png'; 
import Carrello from '../components/images/icons/IconCarrelloW65.png';
import Lente from '../components/images/icons/searchHCTr.png';
import iconPhone from '../components/images/icons/iconPhoneW50.png';
import iconLogout from '../components/images/icons/iconLogoutW50.png';
import './header.scss'
import '../css/fonts/fonts.scss';

function Header() {
   // useState
    const [searchQuery, setSearchQuery] = useState('');
    const [hiddenHeader, setHiddenHeader] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const [width, setWidth] = useState(0);
    const [firstHeader, setFirstHeader] = useState(false);
    const [countCart, setCountCart] = useState(0);
    const [hasCheckedAuth, setHasCheckedAuth] = useState(false);

    const [isLoginHovered, setIsLoginHovered] = useState(false);
    const [isAccountHovered, setIsAccountHovered] = useState(false);
    
    // reactJS hooks
    let location = useLocation();

    // Custom hooks
    const { 
        user, 
        isAuthenticated, 
        getCurrentUser,
        logout, 
        loading: authLoading,
        syncExternalAuth
    } = useAuth();

    const { cart, subscribe, refreshCart } = useCart();
    const { themes, loading: themesLoading, error } = useThemes();

    const { openLoginModal} = useLoginModal();

    // ✅ Gestisci resize
    const handleWidthResize = useCallback(() => {
        const newWidth = window.innerWidth;
        setWidth(newWidth);
        setFirstHeader(newWidth >= 1400);
    }, []);

     // ✅ useEffect per sincronizzazione
    useEffect(() => {
        // Ascolta cambiamenti di autenticazione da altri componenti
        const unsubscribe = authEventBus.subscribe(
            AUTH_EVENTS.AUTH_CHANGED, 
            (data) => {
                //console.log('📢 Header riceve aggiornamento auth:', data);
                syncExternalAuth(data.user, data.isAuthenticated);
            }
        );

        // Ascolta eventi specifici
        const unsubscribeLogin = authEventBus.subscribe(
            AUTH_EVENTS.LOGIN,
            (userData) => {
                //console.log('📢 Header riceve login event');
                syncExternalAuth(userData, true);
            }
        );

        const unsubscribeLogout = authEventBus.subscribe(
            AUTH_EVENTS.LOGOUT,
            () => {
                //console.log('📢 Header riceve logout event');
                syncExternalAuth(null, false);
            }
        );

        const unsubscribeUpdate = authEventBus.subscribe(
            AUTH_EVENTS.USER_UPDATED,
            (userData) => {
                //console.log('📢 Header riceve user update');
                syncExternalAuth(userData, true);
            }
        );

        return () => {
            unsubscribe();
            unsubscribeLogin();
            unsubscribeLogout();
            unsubscribeUpdate();
        };
    }, [syncExternalAuth]);

    // ✅ Inizializza l'auth una volta sola al mount
    useEffect(() => {
        const checkAuth = async () => {
            if (!hasCheckedAuth) {
                //console.log('🔄 Header: Verifico autenticazione utente...');
                await getCurrentUser();
                setHasCheckedAuth(true);
            }
        };
        
        checkAuth();
    }, [getCurrentUser, hasCheckedAuth]); 


    // ✅ Ascolta evento di login per refresh carrello
    useEffect(() => {
        const handleLogin = () => {
            //console.log('📢 [Header] Ricevuto evento login, refresho carrello');
            refreshCart();
        };
        
        const unsubscribe = authEventBus.subscribe(AUTH_EVENTS.LOGIN, handleLogin);
        
        return () => {
            unsubscribe();
        };
    }, [refreshCart]);

     // ✅ SOTTOSCRIVITI AGLI AGGIORNAMENTI
    useEffect(() => {
        // Subscribe agli aggiornamenti del carrello
        const unsubscribe = subscribe((updatedCart) => {
            //console.log('🛒 Header: Carrello aggiornato', updatedCart);
            setCountCart(updatedCart?.item_count || 0);
        });
        // Cleanup
        return unsubscribe;
    }, [subscribe]); // ✅ Dipendenza corretta

    // ✅ 2. Aggiorna count cart
    useEffect(() => {
        if (cart && cart.item_count !== undefined) {
            setCountCart(cart.item_count);

        } else {
            setCountCart(0);
        }
    }, [cart]);

     // ✅ Ascolta evento di logout per reset carrello
    useEffect(() => {
        const handleLogout = () => {
            //console.log('📢 [Header] Ricevuto evento logout, refresho carrello');
            refreshCart();
            showToast('👋 Logout effettuato con successo', 'info', 3000);
        };
        
        const unsubscribe = authEventBus.subscribe(AUTH_EVENTS.LOGOUT, handleLogout);
        
        return () => {
            unsubscribe();
        };
    }, [refreshCart]);


    // ✅ 3. Gestisci resize window
    useEffect(() => {
        window.addEventListener("resize", handleWidthResize);
        handleWidthResize();
        
        return () => {
            window.removeEventListener("resize", handleWidthResize);
        };
    }, [handleWidthResize, width]);

    // ✅ 4.location.pathname
    useEffect(() => {
        const isNegozioOnline = location.pathname.includes('negozioonline');
        if(isNegozioOnline) {
            setHiddenHeader(true); 
        } else {
            setHiddenHeader(false);
        } 
    }, [location.pathname]);

    // ✅ 5. Condizioni di loading - CORRETTE
    if (themesLoading || (authLoading && !hasCheckedAuth)) {
        return <div className="header-loading">Caricamento...</div>;
    }
    
    if (error) {
        return <div className="header-error">Errore: {error}</div>;
    }

    const clearSearch = () => {
        setSearchQuery('');
    };

    const handleSearch = (e) => {
        e.preventDefault();
        // Implementa la tua logica di ricerca
    };

    return (
        <>
            {!hiddenHeader && 
            <section className="header" /*style={ showHeader && width < 460 ? {display: "none" } : {display: "flex"}}*/>
            <div className="header-hidded"></div>
                <div className="header__top-bar">
                    <div className='header__bar-conttati'>
                        <img src={iconPhone} 
                            alt="icon of login" 
                            className="image-style"
                            srcSet="" 
                        />
                        <p>+39 366 401 1 401</p>
                    </div>
                        <div className="header__search-bar">
                            <form className={`search-box ${isFocused ? 'focused' : ''}`} onSubmit={handleSearch}>
                                <div className="search-box__icon">
                                    <img src={Lente}
                                        alt=''
                                        className="search-icon" 
                                        srcSet="" 
                                    />
                                </div>
                                <input
                                    type="text"
                                    placeholder="Cerca informazioni per parole chiave..."
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    onFocus={() => setIsFocused(true)}
                                    onBlur={() => setIsFocused(false)}
                                    aria-label="Search"
                                />
                                {searchQuery && (
                                <button type="button" className="search-box__clear" onClick={clearSearch} aria-label="Clear search">
                                    <FiX />
                                </button>
                                )}    
                                <button type="submit" className="search-box__submit" aria-label="Submit search">
                                    Cerca
                                </button>    
                            </form>
                        </div>

                    <div className='header__bar-user'>
                        {isAuthenticated ? (
                            <div className="header-top-bar-user__welcome">
                                <p>Benvenuto!</p>
                                <div className="user__welcome">
                                    <p>{user.nome || ' Utente'}</p>
                                    <img src={iconLogout} alt="incon of logout" title='Disconnettiti' onClick={logout}/>
                                </div>
                            </div>
                        ) : (
                            <>
                                {/* 🔥 LOGIN CON HOVER */}
                                <div 
                                    className="user-navlink" 
                                    onMouseEnter={() => setIsLoginHovered(true)} 
                                    onMouseLeave={() => setIsLoginHovered(false)} 
                                    onClick={() => openLoginModal('login')}
                                >
                                    <img 
                                        src={isLoginHovered ? hoverLoginIcon : normaLoginIcon} 
                                        alt="Accedi"
                                        className={`hover-effect ${isLoginHovered ? 'hovered' : ''}`} 
                                    />   
                                    <p>Accedi</p>
                                </div>
                                
                                {/* 🔥 REGISTRATI CON HOVER */}
                                <div 
                                    className="user-navlink" 
                                    onMouseEnter={() => setIsAccountHovered(true)} 
                                    onMouseLeave={() => setIsAccountHovered(false)} 
                                    onClick={() => openLoginModal('regiterStep1')}
                                >
                                    <img 
                                        src={isAccountHovered ? hoverAccountIcon : normaAccountIcon} 
                                        alt="icon for home"
                                        className={`hover-effect ${isAccountHovered ? 'hovered' : ''}`} 
                                    />
                                    <p>Registrati</p> 
                                </div>
                            </>
                        )}
                    </div>

                    <div className="header__bar-cart">
                        <div>
                            <NavLink to="/negozioonline/carrello">
                            <img className='image-style__kart' src={Carrello} 
                            alt="Cart's Icon" title="Carrello"
                            />
                            </NavLink>
                        </div>
                        <div className="cart-number">
                        <span>{countCart}</span>
                        </div>
                    </div>
                </div>
                {firstHeader && themes && <FirstHeadManifestMenu themes={themes} />} 
                {!firstHeader && themes && <SecondHeadManifestMenu themes={themes}/>}               
            </section>}
        </>
    );
}
export default Header;
